import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAuthContext } from 'shared/components'
import { MODULE_NAME } from '../../strings'
import {
  AccountAvatar,
  AccountCardWrapper,
  ProviderChip,
} from './ReauthenticationDialog.style'
import { getUserInitials } from './ReauthenticationDialog.utils'

interface AccountCardProps {
  providerName?: string
}

// The account being reauthenticated, which can't be changed
const AccountCard = ({ providerName }: AccountCardProps) => {
  const { t } = useTranslation(MODULE_NAME)
  const { user } = useAuthContext()

  return (
    <AccountCardWrapper>
      <AccountAvatar>{getUserInitials(user)}</AccountAvatar>
      <Box minWidth={0} flex={1}>
        <Typography variant="caption" color="grey.600" display="block">
          {t('login.email')}
        </Typography>
        <Typography
          variant="body2"
          fontWeight={600}
          sx={{ overflowWrap: 'anywhere' }}
        >
          {user?.email}
        </Typography>
      </Box>
      {providerName && <ProviderChip size="small" label={providerName} />}
    </AccountCardWrapper>
  )
}

export default AccountCard
